<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="3%" class="error-404">
  <h1>{{ 'text.page-not-found' | translate }}</h1>
  <p>400</p>
</div>
